import React from 'react'

import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import DelegateSelector from './DelegateSelector/DelegateSelector'
import DelegateData from './DelegateData/DelegateData'

const body = ({
  data = [],
  addRowClicked,
  deleteRowClicked,
  inputChanged,
  delegateForm,
  dropdownOptions,
  currentCompany,
  cancelDelegateChanged
}) => {
  return (
    <Aux>
      <DelegateSelector
        addRowClicked={addRowClicked}
        inputChanged={inputChanged}
        forms={delegateForm}
        dropdownOptions={dropdownOptions}
        currentCompany={currentCompany}
      />
      <DelegateData
        data={data}
        deleteRowClicked={deleteRowClicked}
        dropdownOptions={dropdownOptions}
        cancelDelegateChanged={cancelDelegateChanged}
      />
    </Aux>
  )
}

export default body
